import { useQueryClient } from '@tanstack/react-query';

import useQuery from '@/core/hooks/api/useQuery';
import Api from '@/core/lib/new-architecture/api';
import getToken from '@/core/lib/new-architecture/query/token';
import type { Query } from '@/core/lib/new-architecture/query/types.query';

const keys = {
  base: ['KEY_TO_PREVENT_COLLISIONS', '/interests'] as const,
};

type AwaitedInterests = Awaited<ReturnType<typeof Api.query.interests.get>>;

const useInterests: Query<AwaitedInterests, void> = ({ token, enabled }) => {
  return useQuery<AwaitedInterests>({
    queryKey: keys.base,
    queryFn: async () => Api.query.interests.get.call(undefined, await getToken(token)),
    enabled,
  });
};

const useInvalidate = () => {
  const queryClient = useQueryClient();
  const invalidate = () => queryClient.invalidateQueries({ queryKey: keys.base });
  return { invalidate };
};

export default { useInterests, useInvalidate };
